import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDetentDown = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "arrow_downward",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_4",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 24,
				height: 24
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_0_4)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "arrow_downward_2",
				d: "M11 4V16.175L5.4 10.575L4 12L12 20L20 12L18.6 10.575L13 16.175V4H11Z",
				fill: "currentColor"
			})
		})]
	})
});
export default SvgDetentDown;
